export const resourceLabelOptions = ['Resource', 'Club/Group', 'Business/Organization']